import React, { useState } from 'react';
import MobileCard from '../mobileCard/MobileCard';
import TimelapsePorPeriodo from './TimelapsePorPeriodo';
import CamStatus from '../camStatus/CamStatus';
import FirstLastImageCompare from './FirstLastImageCompare';
import RayosXCompare from './RayosXCompare';
import VivoRedes from '../vivoRedes/VivoRedes';
import MedirObra from '../medir/MedirObra';
import FotoEnVivo from '../fotoEnVivo/FotoEnVivo';

const TABS = [
  { id: 'foto-en-vivo', label: 'Foto en vivo' },
  { id: 'timelapse', label: 'Timelapse de la Obra' },
  { id: 'antes-despues', label: 'Antes y Ahora' },
  { id: 'rayos-x', label: 'Rayos X' },
  { id: 'vivo-redes', label: 'En vivo en redes' },
  { id: 'medir', label: 'Medir' },
];

// Tarjeta del Inicio de la cámara: Foto en vivo (la última foto que subió la cámara, se actualiza sola; la
// pestaña que se abre primero) / Timelapse / Antes y Ahora / Rayos X en el
// mismo espacio, más "En vivo en redes" (vivo real de Neolink hacia YouTube/Facebook/Instagram) y "Medir"
// (distancias, superficies y alturas sobre la foto con la cámara calibrada).
const InicioMediaCard = ({ userdata, onGoToFirstImage, onOpenEditor, empresa }) => {
  const [inicioSubTab, setInicioSubTab] = useState(() => {
    const pedido = new URLSearchParams(window.location.search).get('inicioTab');
    return TABS.some((t) => t.id === pedido) ? pedido : 'foto-en-vivo';
  });

  return (
    <MobileCard className="border-0 shadow-xl overflow-hidden" padding="p-2 md:p-3">
      <div className="mb-2 flex flex-wrap items-center gap-1 sm:gap-2" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={inicioSubTab === tab.id}
            onClick={() => setInicioSubTab(tab.id)}
            className={`shrink-0 whitespace-nowrap px-2 sm:px-3 py-1.5 rounded-lg text-[13px] sm:text-sm font-medium border transition-colors active:scale-95 ${
              inicioSubTab === tab.id
                ? 'bg-blue-50 text-blue-700 border-blue-200 shadow-sm'
                : 'text-gray-700 border-transparent hover:bg-gray-100'
            }`}
          >
            {tab.label}
            {(tab.id === 'foto-en-vivo' || tab.id === 'rayos-x' || tab.id === 'vivo-redes' || tab.id === 'medir') && (
              <span className="hidden sm:inline ml-1.5 align-middle text-[10px] font-semibold uppercase tracking-wide text-blue-600 bg-blue-100 px-1.5 py-0.5 rounded">
                Nuevo
              </span>
            )}
          </button>
        ))}
      </div>
      {inicioSubTab === 'foto-en-vivo' && <FotoEnVivo user={userdata} />}
      {inicioSubTab === 'antes-despues' && (
        <FirstLastImageCompare user={userdata} onGoToFirstImage={onGoToFirstImage} />
      )}
      {inicioSubTab === 'rayos-x' && <RayosXCompare user={userdata} />}
      {inicioSubTab === 'medir' && <MedirObra user={userdata} />}
      {inicioSubTab === 'vivo-redes' && (
        <VivoRedes
          userdata={userdata}
          empresa={empresa || { customerId: userdata?.customerId || '', customerName: '', customerPhone: '' }}
        />
      )}
      {inicioSubTab === 'timelapse' && (
        <>
          <TimelapsePorPeriodo userdata={userdata} onOpenEditor={onOpenEditor} />
          <div className="mt-2 flex items-center justify-center">
            <CamStatus feedID={userdata.feedID} />
          </div>
        </>
      )}
    </MobileCard>
  );
};

export default InicioMediaCard;
